import { Site } from 'graph/Site'
import { createContext } from 'react'

export type AppState = {
  domain: string
  site: Site['site']
}

/**
 * AppContext
 * Use this to store app specific config values that are
 * shared across many components.
 */
export const AppContext = createContext<AppState>({
  domain: '',
  // @ts-ignore
  site: null,
})
